import { Icons } from '@/components/Shares/Icons';
import { ActionIcon, Group, Image } from '@mantine/core';
import Link from 'next/link';
import classes from './NavbarTop.module.css';
export const NavbarTop: React.FC = () => {
  return <Group align="center" mx="auto" gap={1} mt={{
    base: 0,
    lg: -20
  }} className={classes.navbarTop}>
      <ActionIcon bg="var(--mantine-color-dark)" w={46} h={46} hiddenFrom="lg">
        <Icons className="icon-pr-flat-exit" fontSize={24} color="var(--icon-color)" />
      </ActionIcon>
      <Link href={'/'}>
        <Image src="/assets/images/bonus.svg" alt="Bonus" visibleFrom="lg" />
        <Image src="/assets/gift.svg" alt="Bonus" hiddenFrom="lg" p={4} />
      </Link>
      <Link href={'/'}>
        <Image src="/assets/images/spin.svg" alt="Bonus" visibleFrom="lg" />
        <Image src="/assets/spin.svg" alt="Bonus" hiddenFrom="lg" p={4} />
      </Link>
    </Group>;
};